import {Injectable, makeStateKey} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {
    PublicTripCalculatorDefaults,
    PublicTripFuelType,
    PublicTripVehicleClass,
} from '../interfaces/public-trip-calculator';
import {ApiService} from './api.service';

const PUBLIC_TRIP_DEFAULTS_PREFIX = 'public_trip_calculator_defaults_';

@Injectable({providedIn: 'root'})
export class PublicTripCalculatorService extends ApiService {
    private defaultsCache = new Map<string, PublicTripCalculatorDefaults>();

    getDefaults(
        vehicleClass: PublicTripVehicleClass,
        fuelType: PublicTripFuelType,
    ): Observable<PublicTripCalculatorDefaults> {
        const cacheKey = `${vehicleClass}_${fuelType}`;
        const memoryCached = this.defaultsCache.get(cacheKey);
        if (memoryCached) {
            return of(memoryCached);
        }

        const stateKey = makeStateKey<PublicTripCalculatorDefaults>(`${PUBLIC_TRIP_DEFAULTS_PREFIX}${cacheKey}`);
        const transferCached = this.transferState.get(stateKey, null);
        if (transferCached) {
            this.defaultsCache.set(cacheKey, transferCached);
            return of(transferCached);
        }

        const url = `${this.apiHost}/front/trip-calculator/defaults?vehicle_class=${vehicleClass}&fuel_type=${fuelType}`;

        return this.http.get<PublicTripCalculatorDefaults>(url, this.httpOptions).pipe(
            tap((defaults) => {
                this.defaultsCache.set(cacheKey, defaults);
                this.transferState.set(stateKey, defaults);
            }),
        );
    }
}
